import WidgetContainer from "@/components/WidgetContainer2/WidgetContainer2";
import { memo, useEffect, useState } from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import { useTranslation } from "react-i18next";
import Widget1 from "../widgets/bulletin/Widget1/Widget1";
import Widget2 from "../widgets/bulletin/Widget2/Widget2";
import WidgetControlButton from "./WidgetControlButton";
import useDashboardStore from "@/state/dashboard";
import { shallow } from "zustand/shallow";
import { LegendItem } from "../components/Legend/LegendItem";
import WidgetDataQuality from "../widgets/WidgetDataQuality";
import WidgetKeyIndicator from "../widgets/WidgetKeyIndicator";
import Widget3 from "../widgets/bulletin/Widget3";
import { pull } from "../../utils";
import WidgetOverall from "../widgets/bulletin/WidgetOverall/WidgetOverall";
const ReactGridLayout = WidthProvider(Responsive);

const Bulletin = ({ teiData, listProvince }) => {
  const { t } = useTranslation();

  const changeAdditionalStateProperty = useDashboardStore(
    (state) => state.changeAdditionalStateProperty
  );
  const { additionalState } = useDashboardStore(
    (state) => ({ additionalState: state.additionalState }),
    shallow
  );

  useEffect(() => {
    changeAdditionalStateProperty("widgetNutriPeriod", {
      dhis2Period: "2023Q2",
    });
  }, []);

  const [dataWidget1, setWidget1] = useState("sample");
  const [dataWidget2, setWidget2] = useState("sample");
  const [dataWidget3, setWidget3] = useState("sample");

  useEffect(() => {
    (async () => {
      const pregnantWomen = await pull("/api/getDashboard9Widget1Data");
      const pregnantTeen = await pull("/api/getDashboard9Widget2Data");
      const ancIFA = await pull("/api/getDashboard9Widget3Data");
      const vitaminASupplementation = await pull(
        "/api/getDashboard9WidgetVitaminAData"
      );

      setWidget1({
        pregnantWomen: pregnantWomen.data.rows,
        pregnantTeen: pregnantTeen.data.rows,
        ancIFA: ancIFA.data.rows,
      });

      const childrenUnder5 = await pull("/api/getDashboard9Widget4Data");
      const earlyInit = await pull("/api/getDashboard9Widget5Data");
      const exclusiveBreastfeeding = await pull(
        "/api/getDashboard9Widget6Data"
      );

      setWidget2({
        childrenUnder5: childrenUnder5.data.rows,
        earlyInit: earlyInit.data.rows,
        exclusiveBreastfeeding: exclusiveBreastfeeding.data.rows,
      });

      const institutionalLowBirthWeightRate = await pull(
        "/api/getDashboard9Widget7Data"
      );
      const institutionalOverBirthWeightRate = await pull(
        "/api/getDashboard9Widget8Data"
      );
      const childrenAdmittedForSAMTreatment = await pull(
        "/api/getDashboard9Widget11Data"
      );

      setWidget3({
        institutionalLowBirthWeightRate:
          institutionalLowBirthWeightRate.data.rows,
        institutionalOverBirthWeightRate:
          institutionalOverBirthWeightRate.data.rows,
        childrenAdmittedForSAMTreatment: childrenAdmittedForSAMTreatment.data,
        vitaminASupplementation: vitaminASupplementation.data.rows,
      });
    })();
  }, []);

  return (
    <ReactGridLayout
      isDraggable={false}
      breakpoints={{ desktop: 1200 }}
      layouts={{
        desktop: [
          { x: 0, y: 0, w: 12, h: 6, i: "tab" },
          { x: 0, y: 6, w: 12, h: 20, i: "overall" },
          { x: 0, y: 26, w: 12, h: 28, i: "womenDress" },
          { x: 0, y: 54, w: 12, h: 20, i: "baby" },
          { x: 0, y: 74, w: 12, h: 35, i: "3" },
          { x: 0, y: 109, w: 12, h: 68, i: "tableKeyIndicator" },
          { x: 0, y: 177, w: 12, h: 80, i: "tableDataQuality" },
          // { x: 0, y: 15, w: 12, h: 15, i: "footer" },
        ],
      }}
      cols={{ desktop: 12, mobile: 6 }}
      rowHeight={1}
      containerPadding={[0, 0]}
    >
      {/* USE for period selector */}
      {/* <WidgetContainer
        key="tab"
        dashboardIndex={5}
        widgetIndex={0}
        childrenWidgets={[
          {
            widget: (
              <WidgetControlButton
                periodType="Quarterly"
                additionalStateKey="widgetNutriPeriod"
              />
            ),
          },
        ]}
      /> */}
      <WidgetContainer
        key="overall"
        dashboardIndex={5}
        widgetIndex={1}
        styleWidget={{ minHeight: 250 }}
        childrenWidgets={[
          {
            title: (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  minWidth: "100%",
                }}
              >
                <div>
                  <b>{t("DHIS2 nutrition dashboard - LAO PDR")}</b>
                </div>
                <div>
                  <b>{t("Period: JAN-JUN 2024")}</b>
                </div>
              </div>
            ),

            widget: <WidgetOverall data={dataWidget1} />,
          },
        ]}
      />
      <WidgetContainer
        key="womenDress"
        dashboardIndex={5}
        widgetIndex={1}
        styleWidget={{ minHeight: 250 }}
        childrenWidgets={[
          {
            title: t("Overview"),
            widget: <Widget1 data={dataWidget1} />,
          },
        ]}
      />
      <WidgetContainer
        key="baby"
        dashboardIndex={5}
        widgetIndex={2}
        childrenWidgets={[
          {
            widget: <Widget2 data={dataWidget2} />,
          },
        ]}
      />
      <WidgetContainer
        key="3"
        dashboardIndex={5}
        widgetIndex={4}
        childrenWidgets={[
          {
            widget: <Widget3 data={dataWidget3} />,
          },
        ]}
      />
      <WidgetContainer
        key="tableKeyIndicator"
        dashboardIndex={5}
        widgetIndex={4}
        childrenWidgets={[
          {
            title: t("JAN-JUN 2024 Nutrition Scorecard - Key Indicators"),
            widget: <WidgetKeyIndicator />,
          },
        ]}
        headerRightItem={
          <div
            style={{
              minWidth: 120,
              display: "flex",
              flexDirection: "column",
              gap: 4,
            }}
          >
            <LegendItem text={t("Good")} color="#99E573" />
            <LegendItem text={t("Average")} color="#FFDE59" />
            <LegendItem text={t("Poor")} color="#FF5757" />
            <LegendItem text={t("Not Reported")} color="#C0C0C0" />
          </div>
        }
      />
      <WidgetContainer
        key="tableDataQuality"
        dashboardIndex={5}
        widgetIndex={4}
        childrenWidgets={[
          {
            title: t("JAN-JUN 2024 Nutrition Scorecard - Data Quality"),
            widget: <WidgetDataQuality />,
          },
        ]}
        headerRightItem={
          <div
            style={{
              marginTop: "200px",
              minWidth: 120,
              display: "flex",
              flexDirection: "column",
              gap: 4,
            }}
          >
            <LegendItem text={t("Good")} color="#99E573" />
            <LegendItem text={t("Average")} color="#FFDE59" />
            <LegendItem text={t("Poor")} color="#FF5757" />
          </div>
        }
      />
    </ReactGridLayout>
  );
};

export default memo(Bulletin);
